import React from "react";
import SitePreviewItem from "./SitePreviewItem/SitePreviewItem";

interface Props {
    sites: {
        siteId: string;
        siteName: string;
        actionCount: number;
    }[];
}

const SitePreviewListing = ({ sites }: Props) => (
    <div className="flex flex-col gap-0.25">
        {sites.map((site) => (
            <SitePreviewItem siteId={site.siteId} siteName={site.siteName} actionCount={site.actionCount} key={site.siteId} />
        ))}
    </div>
);

export default SitePreviewListing;
